(function ($) {
    // Carousel depends on Tiny Slider.
    if (typeof tns !== 'function') {
        return;
    }

    var blockClass = 'carousel';
    var dot = '.';

    var gridClass = blockClass + '__grid';
    var itemClass = blockClass + '__item';

    var navClass = blockClass + '__nav';
    var prevClass = blockClass + '__prev';
    var nextClass = blockClass + '__next';
    var navDotsClass = blockClass + '__dots';
    var navDotClass = blockClass + '__dot';

    $(function () {
        $(dot + blockClass).each(function (carouselIndex, carouselNode) {
            var carousel = $(carouselNode);

            var grid = carousel.find(dot + gridClass);
            var items = carousel.find(dot + itemClass);

            // No grid? Too few slides? No carousel.
            if (grid.length === 0 || items.length < 2) {
                return;
            }

            // Container for navigation controls.
            var nav = carousel.find(dot + navClass);

            if (nav.length === 0) {
                nav = $('<div class="' + navClass + '"></div>');
                carousel.append(nav);
            }

            // Navigation controls.
            var prev = nav.find(dot + prevClass);
            var next = nav.find(dot + nextClass);
            var navDots = nav.find(dot + navDotsClass);

            // No previous slide button?
            if (prev.length === 0) {
                prev = $('<button class="' + prevClass + '"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.42z"/></svg> <span class="screen-reader-text">Previous</span></button>');
                nav.prepend(prev);
            }

            // No next slide button?
            if (next.length === 0) {
                next = $('<button class="' + nextClass + '"><span class="screen-reader-text">Next</span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8.59 16.58L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42z"/></svg></button>');
                nav.append(next);
            }

            // No container for navigation "dots"?
            if (navDots.length === 0) {
                navDots = $('<div class="' + navDotsClass + '"></div>');

                // Append a "dot" for each slide.
                items.each(function (itemIndex, itemNode) {
                    var navDot = $('<button class="' + navDotClass + '"><span class="screen-reader-text">Image #' + (itemIndex + 1) + '</span></button>');
                    navDots.append(navDot);
                });

                prev.after(navDots);
            }

            // Initialize Tiny Slider carousel.
            tns({
                container: grid.get(0),
                nav: true,
                navContainer: navDots.get(0),
                controls: true,
                prevButton: prev.get(0),
                nextButton: next.get(0),
                autoplay: true,
                autoplayButtonOutput: false,
                autoplayHoverPause: true,
                autoplayTimeout: 8000,
                speed: 400
            });

            // Lightbox depends on Magnific Popup.
            if (typeof $.fn.magnificPopup !== 'function') {
                return;
            }

            // Lightbox uses data object to prevent gallery being populated by
            // duplicate links created by Tiny Slider.
            items.find('a[href]').each(function (linkIndex, linkNode) {
                var link = $(linkNode);

                link.magnificPopup({
                    type: 'image',
                    items: carousel.data('carousel-items'),
                    index: link.data('carousel-index'),
                    gallery: {
                        enabled: true,
                    }
                });
            });
        });
    });
})(jQuery);
